import { render, staticRenderFns } from "./PendingCentresTable.vue?vue&type=template&id=747d7959&scoped=true&"
import script from "./PendingCentresTable.vue?vue&type=script&lang=js&"
export * from "./PendingCentresTable.vue?vue&type=script&lang=js&"
import style0 from "./PendingCentresTable.vue?vue&type=style&index=0&id=747d7959&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d7959",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDataTable,VDivider,VSpacer,VTextField,VToolbar,VToolbarTitle})
